/* eslint-disable import/prefer-default-export */
import { attunedApi } from 'services';

export const getIdentity = async () => {
    const response = await attunedApi.get('/token/identity');
    return response.data;
};
